import { Bike, Home } from "lucide-react";

// Default = the phone-frame mobile experience (unchanged).
// `wide` = responsive: still a 480px phone column on mobile, but expands to a
// full desktop canvas at lg+ so the rider experience can go map-first.
export default function RiderShell({ children, wide = false }) {
  const inner = wide
    ? "mx-auto w-full max-w-[480px] lg:max-w-[1440px] min-h-screen bg-background relative shadow-2xl sm:border-x border-border"
    : "mx-auto max-w-[480px] min-h-screen bg-background relative shadow-2xl sm:border-x border-border";
  return (
    <div className="min-h-screen bg-neutral-950">
      <div className={inner} data-testid="rider-app">
        {children}
      </div>
    </div>
  );
}

export function RiderTopBar() {
  return (
    <header className="sticky top-0 z-30 flex items-center gap-2 px-4 h-14 bg-background/85 backdrop-blur border-b border-border">
      <a href="https://velopaths.com" className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-testid="nav-logo-home">
        <Bike className="w-5 h-5 text-primary" />
        <span className="font-heading font-bold tracking-tight">VeloPaths</span>
      </a>
      <a href="https://velopaths.com" className="ml-auto inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-primary transition-colors" data-testid="nav-home-link"><Home className="w-4 h-4" />Home</a>
    </header>
  );
}
